module.exports = __webpack_public_path__ + "static/media/dropdown-action.6f5cd53b.svg";